import moment from 'moment'
import _ from 'lodash'
import fileService from "../services/fileService";

// 로그인 후 우측 상단에 표시될 USER_GB
export default {
    install: (app, options) => {
        app.config.globalProperties.$userGbKR = (userGb) => {
            switch (userGb) {
                case '01':
                case 'STUDENT':
                    return "학생/취업준비생";
                case '02':
                case 'COMPANY':
                    return "재직자/기업";
                case '03':
                case 'SCHOOL':
                    return "대학/연구실";
                case '04':
                case 'TEACHER':
                    return "강사/전문가";
                case '91':
                case 'SUPER_ADMIN':
                    return "슈퍼 관리자";
                case '92':
                case 'ADMIN':
                    return "관리자";
                case '93':
                case 'PARTNER_ADMIN':
                    return "담당기관 관리자";
                case '99':
                case 'SYSTEM_ADMIN':
                    return "시스템 관리자";
                case 'ALL':
                    return "전체";
                default:
                    return userGb;
            }
        }
        app.config.globalProperties.$gbNameKR = (gbName, gbValue) => {
            if(!gbName || !gbValue) return '-';
            const gb  = app.config.globalProperties.$gb;
            const targetGbGroup = gb[gbName];
            if(targetGbGroup) {
                const result = _.find(targetGbGroup, { value: gbValue});
                return result ? result.label : gbValue;
            } else {
                return gbValue;
            }
        }
        app.config.globalProperties.$generalPhoneNum = (generalPhoneNum) => { // 회사 직통 번호
            if (!/^\d{7,11}$/.test(generalPhoneNum)) return generalPhoneNum; // 7~11자리 숫자가 아니면 그대로 반환
            else if (generalPhoneNum.startsWith("02") && generalPhoneNum.length === 9) {
                return generalPhoneNum.replace(/(02)(\d{3})(\d{4})/, "$1-$2-$3"); // 02 지역번호 (02-XXX-XXXX)
            }
            else if (generalPhoneNum.startsWith("02") && generalPhoneNum.length === 10) {
                return generalPhoneNum.replace(/(02)(\d{4})(\d{4})/, "$1-$2-$3"); // 02 지역번호 (02-XXXX-XXXX)
            }
            else if (/^0[3-9]\d{1}/.test(generalPhoneNum) && generalPhoneNum.length === 10) {
                return generalPhoneNum.replace(/(0\d{2})(\d{3})(\d{4})/, "$1-$2-$3"); // 031, 051 등 (XXX-XXX-XXXX)
            }
            else if (/^0[3-9]\d{1}/.test(generalPhoneNum) && generalPhoneNum.length === 11) {
                return generalPhoneNum.replace(/(0\d{2})(\d{4})(\d{4})/, "$1-$2-$3"); // 031, 051 등 (XXX-XXXX-XXXX)
            }
            else if (/^01\d/.test(generalPhoneNum) && generalPhoneNum.length === 11) {
                return generalPhoneNum.replace(/(01\d)(\d{4})(\d{4})/, "$1-$2-$3"); // 휴대폰 (010-XXXX-XXXX)
            }
            else if (/^\d{4}\d{4}$/.test(generalPhoneNum)) {
                return generalPhoneNum.replace(/(\d{4})(\d{4})/, "$1-$2"); // 대표번호 (1577-XXXX)
            }
        }
        app.config.globalProperties.$phoneNum = (phoneNum) => { // 핸드폰 번호
            if(!phoneNum) return '-';
            else if(phoneNum.length !== 11) return phoneNum;
            else return phoneNum.substring(0,3) + '-' + phoneNum.substring(3,7) + '-' + phoneNum.substring(7);
        }
        app.config.globalProperties.$bizNum = (bizNum) => { // 사업자등록번호
            if(!bizNum) return '-';
            else if(bizNum.length !== 10) return bizNum;
            else return bizNum.substring(0,3) + '-' + bizNum.substring(3,5) + '-' + bizNum.substring(5);
        }
        app.config.globalProperties.$corpNum = (corpNum) => { // 법인등록번호
            if(!corpNum) return '-';
            else if(corpNum.length !== 13) return corpNum;
            else return corpNum.substring(0,6) + '-' + corpNum.substring(6);
        }
        app.config.globalProperties.$dateToWeekDay = (date) => {
            const WEEKDAYS = ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"];
            return WEEKDAYS[moment(date).day()];
        }
        app.config.globalProperties.$dateToWeekDayShort = (date) => {
            const WEEKDAYS = ["일", "월", "화", "수", "목", "금", "토"];
            return WEEKDAYS[moment(date).day()];
        }
        app.config.globalProperties.$yyyymm = (yyyymm) => {
            if(!yyyymm) {
                return '-';
            } else if (yyyymm.length < 6) {
                return yyyymm;
            } else {
                const result = moment(yyyymm).format('YYYY.MM');
                if(result === 'Invalid date') {
                    return `${yyyymm.substring(0,4)}.${yyyymm.substring(4)}`;
                } else {
                    return result;
                }
            }
        }
        app.config.globalProperties.$yyyymmdd = (yyyymmdd) => {
            if(!yyyymmdd) {
                return '-';
            } else if (yyyymmdd.length < 8) {
                return yyyymmdd;
            } else {
                const result = moment(yyyymmdd).format('YYYY.MM.DD');
                if(result === 'Invalid date') {
                    return `${yyyymmdd.substring(0,4)}.${yyyymmdd.substring(4)}`;
                } else {
                    return result;
                }
            }
        }
        app.config.globalProperties.$yyyymmddHHmm = (date) => {
            if(!date) {
                return '-';
            } else {
                return moment(date).format('YYYY.MM.DD HH:mm');
            }
        }
        app.config.globalProperties.$yyyymmddHHmmss = (date) => {
            if(!date) {
                return '-';
            } else {
                return moment(date).format('YYYY.MM.DD. HH:mm:ss');
            }
        }
        app.config.globalProperties.$yyyymmddOrHHmm = (date) => {
            if(!date) {
                return '-';
            }else if (date.length < 8) {
                return date;
            }

            const now = moment();
            const newDate = moment(date);
            if(now.format('YYYYMMDD') !== newDate.format('YYYYMMDD')) {
                return newDate.format('YYYY.MM.DD');
            }  else {
                return newDate.format('HH:mm');

            }
        }
        app.config.globalProperties.$number = (number) => {
            if(number === undefined || number === null) return '';
            return Intl.NumberFormat().format(number);
        }
        app.config.globalProperties.$numberZero = (number) => {
            if(number === undefined || number === null) return '0';
            return Intl.NumberFormat().format(number);
        }
        app.config.globalProperties.$fileSize = (size) => {
            return app.config.globalProperties.$number((size / (1024)).toFixed(2)) + 'kb';
        }
        app.config.globalProperties.$movPlayHm = (movPlayHm) => { // movPlayHm = 00:00:00
            if(movPlayHm === undefined || movPlayHm === null) return '';
            const temp = movPlayHm.split(":");
            if(temp.length !== 3) return movPlayHm;
            else {
                let arr = ['', '', ''];
                if(temp[0] !== "00") {
                    const hh = temp[0][0] === '0' ? temp[0][1] : temp[0];
                    arr[0] = `${hh}시간`;
                }
                if(temp[1] !== "00") {
                    const hh = temp[1][0] === '0' ? temp[1][1] : temp[1];
                    arr[1] = `${hh}분`;
                }
                if(temp[2] !== "00") {
                    const hh = temp[2][0] === '0' ? temp[2][1] : temp[2];
                    arr[2] = `${hh}초`;
                }
                return arr.join('');
            }
        }
        app.config.globalProperties.$download = (fileDir) => { // 파일다운로드
            if(fileDir === undefined || fileDir === null) return '';
            const a = document.createElement('a');
            a.href = fileDir;
            a.target = '_blank';
            a.click();
        }
        app.config.globalProperties.$downloadSave = (fileDir) => { // 파일다운로드(즉시저장)
            if(fileDir === undefined || fileDir === null) return '';
            const a = document.createElement('a');
            a.href = fileDir;
            let fileName = '';
            try {
                const url = new URL(fileDir, window.location.origin);
                const segments = url.pathname.split('/').filter(Boolean);
                fileName = segments.length ? segments[segments.length - 1] : '';
            } catch (e) {
                const segments = String(fileDir).split('/').filter(Boolean);
                fileName = segments.length ? segments[segments.length - 1] : '';
            }
            if(fileName) {
                const [nameOnly] = fileName.split('?');
                a.setAttribute('download', nameOnly || '');
            } else {
                a.setAttribute('download', '');
            }
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }
        app.config.globalProperties.$downloadForPrivate = (attach) => { // private 파일다운로드
            const { fileDir, fileName } = attach;

            if(!fileDir || !fileName) {
                return false;
            }

            let paramObj = {
                keyName: fileDir,
                originalFilename: fileName,
            };

            fileService.downloadFile(paramObj)
                .then( async (res) => {
                    // console.log(res);
                    try {
                        const href = URL.createObjectURL(res.data);
                        // create "a" HTML element with href to file & click
                        const link = document.createElement('a');
                        link.href = href;
                        link.setAttribute('download', fileName); //or any other extension
                        document.body.appendChild(link);
                        link.click();

                        // clean up "a" element & remove ObjectURL
                        document.body.removeChild(link);
                        URL.revokeObjectURL(href);
                    } catch(e) {
                        console.log(e);
                    }
                }).catch( (error) =>  {
                // console.log(error);
            });
        }
        app.config.globalProperties.$pageListBoardNo = (list, totalCount, pageSize, currentPage) => { // 페이징처리된 목록의 게시물번호
            _.each(list, (el, index) => {
                el.boardNo = (totalCount - (pageSize*(currentPage-1))) - index;
            });
            return list || [];
        }
        app.config.globalProperties.$pageListPorpId = (list, totalCount, pageSize, currentPage) => { // 페이징처리된 목록의 게시물번호
            _.each(list, (el, index) => {
                el.propId = (totalCount - (pageSize*(currentPage-1))) - index;
            });
            return list || [];
        }
        app.config.globalProperties.$pageListUserId = (list, totalCount, pageSize, currentPage) => { // 페이징처리된 목록의 게시물번호
            _.each(list, (el, index) => {
                el.userId = (totalCount - (pageSize*(currentPage-1))) - index;
            });
            return list || [];
        }
        // 'YYYYMMDD' → Date 객체로 변환
        app.config.globalProperties.$parseYMD = (ymd) => {
            if (!ymd || ymd.length !== 8) return null;
            const year = ymd.slice(0, 4);
            const month = ymd.slice(4, 6);
            const day = ymd.slice(6, 8);
            return new Date(`${year}-${month}-${day}`);
        };
        // 날짜를 "연-월-일"까지만 남기기
        app.config.globalProperties.$getDateOnly = (date) => {
            return new Date(date.getFullYear(), date.getMonth(), date.getDate());
        };
        // 신청 접수중인지 확인
        app.config.globalProperties.$isInRegPeriod = (startYmd, endYmd) => {
            const today = app.config.globalProperties.$getDateOnly(new Date());
            const start = app.config.globalProperties.$getDateOnly(app.config.globalProperties.$parseYMD(startYmd));
            const end = app.config.globalProperties.$getDateOnly(app.config.globalProperties.$parseYMD(endYmd));
            return start && end && today >= start && today <= end;
        };
        // 신청 마감인지 확인
        app.config.globalProperties.$isAfterRegEnd = (endYmd) => {
            const today = app.config.globalProperties.$getDateOnly(new Date());
            const end = app.config.globalProperties.$getDateOnly(app.config.globalProperties.$parseYMD(endYmd));
            return end && today > end;
        };

    }
}
